import React from 'react';
import { IconMsgSparkleOutlineDuo18 } from 'nucleo-ui-outline-duo-18';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import {
  aiIconGradient,
  AiIconGradientDefs,
} from '@/components/Header/components/UnifiedRightNode/aiIconGradient';
import { sidebarIconStrokeWidth } from '@/modules/corporate/modules/admin/components/Sidebar/nav-icon';
import {
  SIDEBAR_FOCUS_RING,
  TOP_BAR_ACTION_BORDER,
  TOP_BAR_ACTION_HOVER,
  TOP_BAR_ACTION_OPEN,
  TOP_BAR_ACTION_TEXT,
  TOP_BAR_AI_ICON_TEXT,
} from '@/modules/corporate/modules/admin/components/Sidebar/theme';

interface CoachOrbButtonProps {
  isOpen?: boolean;
  onClick: () => void;
}

export function CoachOrbButton(props: CoachOrbButtonProps) {
  const { isOpen = false, onClick } = props;
  const { t } = useTranslation(['Common']);
  const { isMobile } = useScreen();

  return (
    <button
      aria-expanded={isOpen}
      className={cn(
        'flex cursor-pointer items-center gap-4 rounded-8 border border-solid px-10 py-6 text-[1.4rem] font-semibold leading-[2rem] transition-colors duration-100',
        TOP_BAR_ACTION_BORDER,
        TOP_BAR_ACTION_TEXT,
        TOP_BAR_ACTION_HOVER,
        isOpen && TOP_BAR_ACTION_OPEN,
        SIDEBAR_FOCUS_RING,
      )}
      type="button"
      onClick={onClick}>
      <AiIconGradientDefs />
      <IconMsgSparkleOutlineDuo18
        className={cn('h-16 w-16 flex-shrink-0', TOP_BAR_AI_ICON_TEXT, aiIconGradient)}
        strokeWidth={sidebarIconStrokeWidth(16)}
      />
      {isMobile ? null : <span className="px-2">{t('Common:KnowledgeBase.Coach')}</span>}
    </button>
  );
}
